import { AdaRequestsTable } from "../../component/AdaRequestsTable";

export default function AdaRequestsPage() {
  return <AdaRequestsTable />;
}
